<template>
  <ionic-vue-page
    v-bind:title="screenTitle"
    v-bind:showMenuButton="false"
    v-bind:showRefresher="false"
  >
    <ion-list class="ion-no-padding">
      <ion-item>
        <ion-avatar v-if="currentUser.photoURL" slot="start">
          <img v-bind:src="currentUser.photoURL" />
        </ion-avatar>
        <ion-label>
          <h2 class="h-f-m" v-html="currentUser.displayName"></h2>
          <p class="h-f-m" v-html="currentUser.email"></p>
        </ion-label>
      </ion-item>
    </ion-list>

    <error-message v-if="error" v-bind:message="error"></error-message>
  </ionic-vue-page>
</template>

<script>
import firebase from "firebase";

export default {
  name: "Profile",
  data() {
    return {
      screenTitle: "Account",
      currentUser: false,
      displayName: "",
      password: "",
      error: false
    };
  },

  created() {
    if (firebase.auth().currentUser) {
      this.currentUser = firebase.auth().currentUser;
    }
  },

  methods: {
    async updateUsername() {
      const loading = await this.$ionic.loadingController.create({
        message: "Updating display name..."
      });
      loading.present();

      this.currentUser
        .updateProfile({ displayName: this.displayName })
        .then(() => {
          this.displayName = "";
          this.error = "";
          this.showToast("You have successfully updated your display name.");
        })
        .catch(error => {
          this.error = error.message;
        })
        .finally(() => {
          loading.dismiss();
        });
    },

    async updatePassword() {
      const loading = await this.$ionic.loadingController.create({
        message: "Updating password..."
      });
      loading.present();

      this.currentUser
        .updatePassword(this.password)
        .then(() => {
          this.password = "";
          this.error = "";
          this.showToast("You have successfully updated your password.");
        })
        .catch(error => {
          this.error = error.message;
        })
        .finally(() => {
          loading.dismiss();
        });
    },

    async showToast(message) {
      const toast = await this.$ionic.toastController.create({
        message: message,
        showCloseButton: true,
        position: "bottom",
        closeButtonText: "Done",
        duration: 2000
      });
      return await toast.present();
    }
  }
};
</script>